__turbopack_context__.v({
  "actions": "index-module__B-TZaa__actions",
  "container": "index-module__B-TZaa__container",
  "header": "index-module__B-TZaa__header",
  "modalContent": "index-module__B-TZaa__modalContent",
  "optionCard": "index-module__B-TZaa__optionCard",
  "optionLabel": "index-module__B-TZaa__optionLabel",
  "optionSubtitle": "index-module__B-TZaa__optionSubtitle",
  "optionsGrid": "index-module__B-TZaa__optionsGrid",
  "section": "index-module__B-TZaa__section",
  "sectionTitle": "index-module__B-TZaa__sectionTitle",
  "selected": "index-module__B-TZaa__selected",
  "submitButton": "index-module__B-TZaa__submitButton",
  "subtitle": "index-module__B-TZaa__subtitle",
  "title": "index-module__B-TZaa__title",
});
